import { render, staticRenderFns } from "./SideView.vue?vue&type=template&id=3e2ab246&scoped=true&"
import script from "./SideView.vue?vue&type=script&lang=js&"
export * from "./SideView.vue?vue&type=script&lang=js&"
import style0 from "./SideView.vue?vue&type=style&index=0&id=3e2ab246&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2ab246",
  null
  
)

export default component.exports